import { useState, useEffect } from "react";

const POLL_INTERVAL = 30000; // 30 seconds

const GENRE_MAP = [
  { keywords: ["rock", "metal", "punk", "hardcore", "grunge", "heavy"], type: "BURST" },
  { keywords: ["ambient", "chill", "sleep", "acoustic", "lo-fi", "lofi", "indie folk", "new age"], type: "RIPPLE" },
  { keywords: ["sad", "blues", "soul", "emo", "heartbreak", "melanchol"], type: "FALL" },
  { keywords: ["classical", "orchestral", "piano", "jazz", "film score", "opera", "symphony"], type: "ORBIT" },
];

// Energy estimates per animation type (since Spotify audio features API is deprecated for new apps)
const TYPE_ENERGY = {
  BURST: 0.9,
  ORBIT: 0.55,
  DRIFT: 0.5,
  FALL: 0.3,
  RIPPLE: 0.25,
};

function getAnimationType(genres = []) {
  const genreStr = genres.join(" ").toLowerCase();

  for (const { keywords, type } of GENRE_MAP) {
    if (keywords.some((kw) => genreStr.includes(kw))) return type;
  }

  return "DRIFT";
}

const useSpotifyTrack = () => {
  const [state, setState] = useState({
    track: null,
    isPlaying: false,
    animationType: "DRIFT",
    energy: 0.5,
    loading: true,
    error: null,
  });

  const fetchTrack = async () => {
    try {
      const res = await fetch("/api/spotify");
      const data = await res.json();

      if (!data.track) {
        setState((prev) => ({ ...prev, track: null, loading: false }));
        return;
      }

      const animationType = getAnimationType(data.genres);
      const energy = TYPE_ENERGY[animationType] ?? 0.5;

      setState({
        track: data.track,
        isPlaying: data.isPlaying,
        animationType,
        energy,
        loading: false,
        error: null,
      });
    } catch (err) {
      setState((prev) => ({ ...prev, loading: false, error: err.message }));
    }
  };

  useEffect(() => {
    fetchTrack();
    const interval = setInterval(fetchTrack, POLL_INTERVAL);
    return () => clearInterval(interval);
  }, []);

  return state;
};

export default useSpotifyTrack;
